exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.access .metismenu a[data-v-76e86a39]:hover{\n  color: black !important;\n}\n.access .metismenu a:hover i[data-v-76e86a39]{\n  color: black !important;\n}\n", ""]);

// exports
